import BaseFormPresenter from "../../../base/BaseFormPresenter";
import { dialog } from "../../../nq-component";
import formatMoney from "../../../formatMoney";

class BankFormPagePresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, deleteObjectUseCase, upsertUseCase) {
    super(view, getObjectUseCase, deleteObjectUseCase, upsertUseCase);
    this.getObjectUseCase = getObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;

    this.object = {};
    this.change = {};
  }

  parseFormattedNumber(formattedStr) {
    if (typeof formattedStr !== "string") return NaN;
    const cleaned = formattedStr.replace(/,/g, "");
    return parseFloat(cleaned);
  }

  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;
    this.view.setObject(this.object);
  }

  async submit() {
    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      const user = this.view.getCurrentUser();

      const { openingBalance } = this.change;
      this.change.client = { id: user.client?.id };
      if (!this.object?.id) {
        this.change.balance = parseFloat(openingBalance);
      }

      dialog.close();
      this.view.submitting();
      await this.save();
      this.view.submissionSuccess();
      dialog.close();
      window.history.back();
      this.view.showSuccessSnackbar("Successfully saved!");
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default BankFormPagePresenter;
